import { Link } from "gatsby";
import React from "react";
import envelope from "../images/envelope.svg";
import github from "../images/github.svg";
import linkedin from "../images/in.svg";
import Navi from "./Navi";

const Header = () => (
  <header className="container">
    <nav className="mb-1">
      {/* Responsive links and hamburger */}
      <Navi />
    </nav>
    {/* Envelope, Email */}
    <div className="info-bar mb-1">
      <div>
        <img
          className="icon"
          src={envelope}
          alt="email"
          height="22px"
          width="27px"
        />
        <span id="mail">dwpwilk@gmail.com</span>
      </div>
      {/* GitHub, LinkedIn icons */}
      <div>
        <a href="https://github.com/Wolfenek" target="_blank" rel="noreferrer">
          <img
            className="icon"
            src={github}
            alt="github"
            height="23px"
            width="28px"
          />
        </a>
        <a href="https://www.linkedin.com/in/dw9" target="_blank" rel="noreferrer">
          <img
            className="icon"
            src={linkedin}
            alt="linkedin"
            height="25px"
            width="25px"
          />
        </a>
      </div>
    </div>
  </header>
);

export default Header;
